module.exports = __webpack_public_path__ + "img/item_image02.4b3284c6.jpg";